import React, { Fragment, PureComponent } from 'react'
import styled from 'styled-components'
import NavBar from "./navigation/nav-bar"
import { Link } from 'react-router-dom'
import Button from './ui/button'
import NavProgressReports from './navigation/nav-progress-reports'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import ProgressReportsPageHero from './ui/progress-reports-page-hero'
import ParameterFilter from './ui/parameter-filter'
import { findIndex } from 'lodash-es'
import { formPagePath } from '../utilities/route'
import { LAPTOP, PHONELG, TABLET } from '../utilities/breakpoints'
import { getThemeStyle } from '../utilities/helpers'
import TableColumnLabel from './ui/table-column-label'
import ProgressIndicator from './progress-reports/progress-indicator'
import DriverStatBar from './ui/driver-stat-bar'
import DriverProgressCard from './progress-reports/driver-progress-card'
import PrSortingWidget from './ui/sorting-widget-progress-reports'
import {
  hasEnoughRespondents,
  getPreviousSurveyId,
  getThemeProgressResults,
  hasLatestResults,
} from '../utilities/progress-reports'
import { sortingService } from '../utilities/sortingService'
import { isNullOrUndefined } from '../utilities/helpers'

class ProgressReportsTheme extends PureComponent {

  handleFiltersChange = value => {
    this.props.onSetPrFilters(value);
  }

  getCurrentCatalystIndex = () => {
    const {
      match: {
        params: { catalystId },
      },
      questionnaire: { catalysts },
    } = this.props;

    return findIndex(catalysts, (catalyst) => catalyst.id === catalystId);
  };


  render() {
    const {
      respondentParameters,
      match: {
        params: { surveyId, languageCode, catalystId },
      },
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        logo,
        isFinished,
        isAfterGameGuest,
        isDialogueActive,
        surveySequence
      },
      currentSurveyStatistics,
      previousSurveyStatistics,
      prSortingType,
      sortAscending,
      useTranslate,
      prFilters,
      improvementProject,
    } = this.props;

    const toThemes = formPagePath(languageCode, surveyId, 'finish', 'themes');
    const previousSurveyId = getPreviousSurveyId(surveySequence, surveyId);
    const themeProgressResults = getThemeProgressResults(
      currentSurveyStatistics, previousSurveyStatistics, questionnaire, surveyId, previousSurveyId, catalystId
    );

    const sortedDrivers = [...themeProgressResults.drivers];
    const sortingFunction = sortingService.getSortingFunction(prSortingType);
    sortedDrivers.sort(sortingFunction(sortAscending));

    const enoughRespondents = hasEnoughRespondents(currentSurveyStatistics) ||
      hasEnoughRespondents(previousSurveyStatistics);

    const surveyAmount = themeProgressResults.results.length;

    const getProgress = (result, previousResult) => {
      if (!isNullOrUndefined(result) && !isNullOrUndefined(previousResult)) {
        return result - previousResult;
      } else {
        return null;
      }
    }

    return (
      <section className="finish-page">
        <ProgressReportsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toThemes}
              afterGame
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"progress"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={true}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{useTranslate("progress_reports.progress_page_title")}</h1>
              <div className="stats-description">
                <p>{useTranslate("progress_reports.progress_page_description")}</p>
              </div>
              <div className="finish-page__intro__nav-holder">
                <NavProgressReports
                  activePage={"themes"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </ProgressReportsPageHero>

        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <div className="finish-page__filters">
            {respondentParameters.length > 0  && (
              <ParameterFilter
                filters={prFilters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            )}
            <PrSortingWidget
              disabled={!hasLatestResults(sortedDrivers)}
              useTranslate={useTranslate}
            />
          </div>

          {enoughRespondents ?
            <Fragment>
              <ThemeResultCard>
                <Header style={{ backgroundColor: getThemeStyle(this.getCurrentCatalystIndex()).bgColor }}>
                  <HeroImage>
                    <img src={getThemeStyle(this.getCurrentCatalystIndex()).bgImage} alt="Shapes"/>
                  </HeroImage>
                  <AllThemesButton
                    as={Link}
                    to={formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'themes')}
                    size={"sm"}
                    kind={"link"}
                  >
                    <svg width="8" height="13" viewBox="0 0 8 13" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 11.4725L3.05533 6.5L8 1.5275L6.47773 0L0 6.5L6.47773 13L8 11.4725Z" />
                    </svg>
                    {useTranslate("data_vault.all_themes_button")}
                  </AllThemesButton>
                  <h2>{themeProgressResults.title}</h2>
                  <p>{themeProgressResults.description}</p>
                </Header>
                <ResultContainer>
                  <ResultColumns className={"labels"}>
                    <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
                    <TableColumnLabel>{useTranslate("progress_reports.label_survey")}</TableColumnLabel>
                    <TableColumnLabel>{useTranslate("data_vault.current_state")}</TableColumnLabel>
                  </ResultColumns>
                  {themeProgressResults.results.map((survey, index) => {
                    const surveyIdentifier = surveySequence.find((s) => s.id === survey.surveyId).identifier;
                    return (
                      <ResultColumns className={"results"} key={index}>
                        <ResultColumn>
                          {index < (surveyAmount - 1) &&
                            <Fragment>
                              <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
                              <ProgressIndicator
                                resultProgress={getProgress(survey.result, themeProgressResults.results[index + 1].result)}
                                showRating={false}
                                size={index > 0 ? "md" : "lg"}
                              />
                            </Fragment>
                          }
                        </ResultColumn>
                        <ResultColumn>
                          <TableColumnLabel>{useTranslate("progress_reports.label_survey")}</TableColumnLabel>
                          <span className={"survey-identifier"} style={index > 0 ? {opacity: "0.5"} : {}}>
                        {surveyIdentifier && surveyIdentifier.length > 0 ?
                          surveyIdentifier
                          :
                          `${useTranslate("progress_reports.label_survey")} ${themeProgressResults.results.length - index}`
                        }
                      </span>
                        </ResultColumn>
                        <ResultColumn>
                          <TableColumnLabel>{useTranslate("data_vault.current_state")}</TableColumnLabel>
                          <DriverStatBar
                            result={survey.result ? survey.result : null}
                            useTranslate={useTranslate}
                            barColor={getThemeStyle(this.getCurrentCatalystIndex()).bgColor}
                            style={index > 0 ? {opacity: "0.5"} : {}}
                            size={index > 0 ? "sm" : "md"}
                          />
                        </ResultColumn>
                      </ResultColumns>
                    )
                  })}
                </ResultContainer>
              </ThemeResultCard>
              <h3 className={"h5 mb-4"}>Drivers</h3>
              {sortedDrivers.map((driver, index) => {
                return (
                  <DriverProgressCard
                    key={index}
                    driver={driver}
                    showNumbers={false}
                    showThemeTitle={false}
                    showPrevious={true}
                    mode={"card"}
                    showStatements={true}
                    showLabels={index < 1}
                    useTranslate={useTranslate}
                  />
                )
              })}
            </Fragment>
            :
            <ThemeResultCard>
              <Header style={{ backgroundColor: getThemeStyle(this.getCurrentCatalystIndex()).bgColor }}>
                <h2>{themeProgressResults.title}</h2>
                <p>{themeProgressResults.description}</p>
                <HeroImage>
                  <img src={getThemeStyle(this.getCurrentCatalystIndex()).bgImage} alt="Shapes"/>
                </HeroImage>
              </Header>
              <ResultContainer>
                <p className="no-results mb-0">{useTranslate("progress_reports.no_progress_reports_for_parameter")}</p>
              </ResultContainer>
            </ThemeResultCard>
          }

        </div>
      </section>
    );
  }
}

export default ProgressReportsTheme;

const AllThemesButton = styled(Button)`
  position: relative;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 3.5rem;
  transition: all .2s ease-in-out;

  svg {
    margin-right: .5rem;
    margin-top: -2px;
  }

  &:hover,
  &:focus {
    text-decoration: none;
    opacity: 0.8;
    color: #fff;

    svg {
      fill: #fff;
    }
  }
`;

const ThemeResultCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 2.5rem;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.06);
`;

const Header = styled.div`
  position: relative;
  border-radius: 10px 10px 0 0;
  padding: 20px 15px;
  color: #fff;
  gap: 20px;
  overflow: hidden;
  
  h2, p {
    max-width: 600px;
  }
  
  h2 {
    margin-bottom: 1.5rem;
  }
  
  p {
    margin-bottom: 0;
  }
  
  @media${TABLET} {
    padding: 30px 20px;
    gap: 20px;
    
    h2, p {
      max-width: 65%;
    }
  }
  
  @media${LAPTOP} {
    padding: 40px 40px 50px;
  }
`;

const HeroImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  display: none;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: 768px) {
    display: flex;

    img {
      width: 30%;
    }
  }
  @media (min-width: 1200px) {
    img {
      width: 38%;
      margin-right: -5%;
    }
  }
`;

const ResultContainer = styled.div`
  padding: 20px 15px;
  
  @media${TABLET} {
    padding: 20px 20px 30px;
  }
  
  @media${LAPTOP} {
    padding: 25px 40px 30px;
  }
`;

const ResultColumns = styled.div`
  &.labels {
    display: none;
  }
  
  .survey-identifier {
    font-weight: 500;
    line-height: 1;
  }
  
  &.results + & {
    margin-top: 12px;
  }
  
  @media${PHONELG} {
    display: grid;
    grid-template-columns: 110px 100px 1fr;
    grid-column-gap: 10px;
    align-items: center;
    
    &.labels {
      display: grid;
      margin-bottom: 8px;
    }
  
  }
  
  @media${TABLET} {
    grid-column-gap: 30px;
  }
`;

const ResultColumn = styled.div`
  margin-bottom: 10px;
  
  .table-column-label {
    margin-bottom: 5px;
  }
  
  @media${PHONELG} {
    margin-bottom: 0;
    
    .table-column-label {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/progress-reports-theme.js